import Swiper, { Pagination } from "swiper";

const ImageWithText = class extends HTMLElement {
  breakpoint = 990;

  connectedCallback() {
    const slider = this.querySelector(".mobile-slider");
    const imagesBelowTextMobile = !!slider?.classList.contains("images-below-text-mobile");

    if (!slider) return;

    const slides = this.querySelectorAll(".image-with-text__image, .image-with-text__video");

    if (slides.length <= 1) return;

    const mobileSlider = document.createElement("div");
    mobileSlider.className = slider.className;

    const wrapper = document.createElement("div");
    const pagination = document.createElement("div");

    mobileSlider.classList.add("swiper", "hide-desktop");
    wrapper.classList.add("swiper-wrapper");
    pagination.classList.add("banner-swiper-pagination");

    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add("swiper-slide");
      wrapper.appendChild(clone);
      slide.classList.add("hide-mobile");
    });

    mobileSlider.appendChild(wrapper);
    mobileSlider.appendChild(pagination);

    if (imagesBelowTextMobile && window.innerWidth < this.breakpoint) {
      slider.append(mobileSlider);
    } else {
      slider.prepend(mobileSlider);
    }

    new Swiper(mobileSlider, {
      autoplay: true,
      loop: true,
      modules: [Pagination],
      pagination: {
        el: ".banner-swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
};

customElements.define("image-with-text", ImageWithText);
